import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deletePaymentCard, getCardList } from "../../../api/payment";
import { message } from "antd";
export const fetchCardList = createAsyncThunk("/card-list", async () => {
  const res = await getCardList();
  return res;
});
export const deleteCard = createAsyncThunk(
  "/delete-payment-method",
  async (id) => {
    const res = await deletePaymentCard(id);
    if (res) {
      message.success("Deleted Successfully");
    }
    return res;
  }
);
const discountSlice = createSlice({
  name: "discount",
  initialState: { value: null },
  reducers: {
    discountValue(state, action) {
      state.value = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCardList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCardList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.res = action.payload;
      })
      .addCase(fetchCardList.rejected, (state, action) => {
        state.isLoading = false;
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(deleteCard.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteCard.fulfilled, (state, action) => {
        state.isLoading = false;
        state.delete = action.payload;
      })
      .addCase(deleteCard.rejected, (state, action) => {
        state.isLoading = false;
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export { discountSlice };
export const { discountValue } = discountSlice.actions;
